export const GET_GROUPS = "get_groups";
export const GET_GROUPS_SUCCESS = "get_groups_success";
export const GET_GROUPS_FAILURE = "get_groups_failure";
export const RESET_GROUPS = "reset_groups";
